<template>
  <div class="app">
    <notifications group="foo" position="bottom right" />
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" src="img/brand/small_landscape.png" width="130" height="40" alt="El Salto logo">
        <img class="navbar-brand-minimized" src="img/brand/logo_100px.png" width="30" height="30" alt="El Salto logo">
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
    
      <b-navbar-nav class="d-md-down-none">
        <b-nav-text>{{ userName }}</b-nav-text>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
       
        <configuracion style="margin-right:30px;"/>
     
      </b-navbar-nav>
   
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <!-- <Breadcrumb :list="list"/> -->
        <br>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <DefaultAside/>
      </AppAside>
    </div>
    <TheFooter>
      <!--footer-->
      <div>
        <!-- <a href="https://coreui.io">CoreUI</a>
        <span class="ml-1">&copy; 2018 creativeLabs.</span> -->
        <span class="ml-1">H. Ayuntamiento de El Salto 2024 - 2027.</span>
      </div>
     <!--  <div class="ml-auto">
        <span class="mr-1">Powered by</span>
        <a href="https://coreui.io">CoreUI for Vue</a>
      </div> -->
    </TheFooter>
  </div>
</template>

<script>
import nav from '@/_nav'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'

import Configuracion from './Configuracion'

import axios from 'axios'
import { mapGetters } from "vuex";

export default {
  name: 'full',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    
    Configuracion
  },
  data () {
    return {
      nav: nav.items
    }
  },
  computed: {
    ...mapGetters([
      "httpURL",
      "sessionToken",
      "userName",
      "permisos",
      "role"
    ]),
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    }
  },
  methods: {
  },
  created() {
      if( sessionStorage.getItem("token") )
        this.$store.dispatch("setSessionToken", sessionStorage.getItem("token"));
      if( localStorage.getItem("token") )
        this.$store.dispatch("setSessionToken", localStorage.getItem("token"));

      if( !this.sessionToken )
        this.$router.push('/login');
      else{
        axios.get(this.httpURL+'/login',{headers:{token:this.sessionToken}})
              .then(res => {
                  this.$store.dispatch("setUserName", res.data.nombre);
                  this.$store.dispatch("setPermisos", res.data.permisos);
                  this.$store.dispatch("setRole", res.data.role);
                  this.$store.dispatch("setUserId", res.data.id);
                  //console.log(res.data.permisos);
                  // res.data.permisos.forEach(element => {
                  //   this.permisos.push(element);
                  // });
                  //this.permisos.push(res.data.permisos);
                  //console.log(this.permisos);
                  this.nav = this.nav.concat(res.data.menu);
                  
              })
              .catch(error => {
                  //console.log('Error: '+error);
                  if(error.response)
                    this.$router.push('/login');
              });
      }
  }
}
</script>

<style>
.sidebar-nav {
  background-color: #242424;
}

</style>
